import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import image_upload from '../assets/images/image_upload.svg';
import add_poll from '../assets/images/add_poll.svg';
import quizpic from '../assets/images/quiz.svg';

const HomeCreatePost = () => {
  const navigate = useNavigate(); 
  
  // Function to handle redirection
  const handleTextareaClick = () => {
    navigate('/create-post');
  };

  return (
    <div className="create_post">
      <form>
        <textarea 
          placeholder="Compose new post..." 
          defaultValue={""} 
          onClick={handleTextareaClick} // Add click handler
        />
        <div className="make_post_action">
          <div className="svg_icon_make_post">
            <Link className="diable_icon">
              <img src={image_upload} alt="" />
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default HomeCreatePost;
